module.exports = __webpack_public_path__ + "static/media/loadData.7a0974b0.svg";